import React from "react";
import sliderInnerSaveEnergy from '../assets/images/save-energy-sliderInner.jpg';

function ContactUs() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInnerSaveEnergy} alt="" />
      </section>
      <section className="sevenScopeSec reduceWasteSec aboutUsSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Get in <span className="hdngBrkr">Touch with us</span> </h2>
          <div className="getFormDiv">
            <div className="getinTchL">
              <div className="getinTchLIn">
                <ul>
                  <li>
                    <div className="getAddDiv">
                      <h3>Our Address</h3>
                      <p>88 Xyz Rd, ABC 66, XYZ</p>
                    </div>
                  </li>
                  <li>
                    <div className="getAddDiv">
                      <h3>Phone Number</h3>
                      <p>Mobile: +91-xxx-xxx-xxxx</p>
                      <p>Landline: 01-xxx-xxx-xx</p>
                    </div>
                  </li>
                  <li>
                    <div className="getAddDiv">
                      <h3>Email Address</h3>
                      <p>support@domain.com</p>
                      <p>help@domain.com</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="getinTchR"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUs;
